{
  "account-existed-dialog": {
    "buttons": {
      "cancel": "Hủy",
      "login": "Đăng nhập"
    },
    "text": {
      "title": "Đã tồn tại tài khoản với email: {{ email }} hoặc số điện thoại: {{ phoneNr }}",
      "title-email-exists": "Đã tồn tại tài khoản với email: {{ email }}",
      "title-phone-exists": "Đã tồn tại tài khoản với số điện thoại: {{ phoneNr }}",
      "hint": "Bạn có thể đăng nhập trực tiếp bằng email/số điện thoại này hoặc sử dụng email/số điện thoại khác để đăng ký.",
      "hint-email-exists": "Bạn có thể đăng nhập trực tiếp bằng email này hoặc sử dụng email khác để đăng ký.",
      "hint-phone-exists": "Bạn có thể đăng nhập trực tiếp bằng số điện thoại này hoặc sử dụng số điện thoại khác để đăng ký."
    }
  }
}
